// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container___3Fdqv","upcoming-wrapper":"upcoming-wrapper___1z7LX","grid":"grid___1sk8l","watch-wrapper":"watch-wrapper___2bF7V","watch":"watch___QaJgx"};